module.exports = __webpack_public_path__ + "img/sn.70436af3.svg";